import { authRoute } from './auth';

export const publicRoute = {
  ...authRoute,
  base: '/',
};
